import React, { useState, useEffect, createContext, useContext } from 'react';
import Axios from 'axios';
import Lodash from 'lodash';
import Moment from 'moment';
import * as DxChart from 'devextreme-react/chart';
import * as DxPieChart from 'devextreme-react/pie-chart';
import MDX from '@mdx-js/runtime';
import { MDXProvider } from '@mdx-js/react';
import { State } from 'react-powerplug';

import System from './System';
import NotFound from './NotFound';

import * as Router from 'react-router-dom';
import * as Antd from 'antd';
import * as AntdIcons from '@ant-design/icons';
import * as COM from '../components/com';

import { AuthContext } from './App';

const Pages = (props) => {
  const [loading, setLoading] = useState(true);
  const [mainMenu, setMainMenu] = useState([]);
  const [contents, setContents] = useState([]);
  const [modalContents, setModalContents] = useState([]);
  const auth = useContext(AuthContext);

  const init = async () => {
    try {
      let { data: userPages } = await Axios.get(`${process.env.REACT_APP_API_BASE_URI}/api/users/pages`, {
        headers: {
          'Authorization': `Bearer ${auth.accessToken}`
        }
      });
      setMainMenu(Lodash.filter(userPages, { menu: 'main' }));
      setContents(userPages);
      setModalContents(Lodash.filter(userPages, { isModal: true }));

      // Fill client cache
      let { data: cacheData } = await Axios.get(`${process.env.REACT_APP_API_BASE_URI}/api/caches`, {
        params: {
          filter: {
            where: {
              client: true
            }
          }
        }
      });
      for (let cache of cacheData) {
        await COM.fetchData({
          connector: cache.connector,
          dataset: cache.dataset,
          filters: JSON.parse(cache.filters),
        }, auth, false, cache.staleTime);
      }
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    setLoading(true);
    init();
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  if (loading) {
    return (
      <Antd.Layout className="layout">
        <Antd.Spin
          tip="Application loading..."
          style={{
            marginTop: 100
          }}
        />
      </Antd.Layout>
    );
  } else {
    return (
      <Antd.Layout className="layout">
        <Antd.Affix offsetTop={1}>
          <Antd.Layout.Header>
            <div className="logo" />
            <Antd.Menu
              className="layout-header"
              theme="dark"
              mode="horizontal"
              defaultSelectedKeys={[window.location.pathname]}
            >
              {Lodash.sortBy(mainMenu, ['menuOrder']).map(child => {
                return (
                  <Antd.Menu.Item
                    key={child.menuLink}
                  >
                    <Router.Link to={child.menuLink}>{child.menuTitle}</Router.Link>
                  </Antd.Menu.Item>
                );
              })}

              {auth.userProfile.roles.indexOf('ADMIN') >= 0
                ? <Antd.Menu.Item key="/system">
                  <Router.Link to="/system">System</Router.Link>
                </Antd.Menu.Item>
                : null}

              <Antd.Menu.SubMenu
                key="/user"
                title={
                  <Antd.Space>
                    <Antd.Avatar>{auth.userProfile.firstName.toUpperCase()[0]}{auth.userProfile.lastName.toUpperCase()[0]}</Antd.Avatar>
                    {auth.userProfile.firstName + ' ' + auth.userProfile.lastName}
                  </Antd.Space>
                }
                style={{
                  float: 'right'
                }}
              >
                <Antd.Menu.Item
                  key="/user/logout"
                  onClick={async () => {
                    await auth.signOut();
                  }}
                >
                  Log out
                </Antd.Menu.Item>
              </Antd.Menu.SubMenu>
            </Antd.Menu>
          </Antd.Layout.Header>
        </Antd.Affix>
        <Antd.Layout className="layout-content">
          <Router.Switch>
            {Lodash.sortBy(contents, ['order']).map((child, idx) => {
              let content = atob(child.content);
              return (
                <Router.Route
                  key={idx}
                  path={child.path}
                  exact={child.path === '/' ? true : false}
                  // strict={true}
                  component={(props) => {
                    const history = Router.useHistory();
                    const params = Router.useParams();
                    const queryParams = Object.fromEntries(new URLSearchParams(Router.useLocation().search));
                    return <MDXProvider>
                      <MDX
                        components={{
                          State
                        }}
                        scope={{
                          COM,
                          Antd,
                          AntdIcons,
                          Moment,
                          Lodash,
                          DxChart,
                          Dx: {
                            Chart: DxChart,
                            PieChart: DxPieChart,
                          },
                          userProfile: auth.userProfile,
                          params: params,
                          queryParams: queryParams,
                          push: history.push,
                        }}
                      >
                        {content}
                      </MDX>
                    </MDXProvider>
                  }}
                />
              );
            })}
            <Router.Route path="/system">
              <System />
            </Router.Route>
            <Router.Route component={NotFound} />
          </Router.Switch>
          {Lodash.sortBy(modalContents, ['order']).map((child, idx) => {
            let content = atob(child.content);
            return <Router.Route
              path={child.path}
              component={(props) => {
                const location = Router.useLocation();
                const history = Router.useHistory();
                const params = Router.useParams();
                const queryParams = Object.fromEntries(new URLSearchParams(Router.useLocation().search));
                return (
                  <Antd.Modal
                    open={true}
                    footer={null}
                    maskClosable={false}
                    width={1000}
                    onCancel={() => {
                      history.goBack();
                    }}
                  >
                    <MDXProvider>
                      <MDX
                        components={{
                          State
                        }}
                        scope={{
                          COM,
                          Antd,
                          AntdIcons,
                          Moment,
                          Lodash,
                          Dx: {
                            Chart: DxChart,
                            PieChart: DxPieChart,
                          },
                          userProfile: auth.userProfile,
                          params: params,
                          queryParams: queryParams,
                          push: history.push,
                        }}
                      >
                        {content}
                      </MDX>
                    </MDXProvider>
                  </Antd.Modal>
                );
              }}
            />
          })}
        </Antd.Layout>
        <Antd.Layout.Footer
          className="layout-footer"
        >
          ©{Moment().format('Y')}
        </Antd.Layout.Footer>
      </Antd.Layout >
    );
  }
}

export default Pages
